/*
 * Frete grátis por região (CEP) — Plenitude
 * Finaliza o esqueleto deixado no tema: lê #plenitude-cep-region-config,
 * engancha no CEP existente ([data-shipping-cep]), deriva a região via ViaCEP
 * e ajusta o threshold da barra de progresso (<progress-bar>).
 *
 * - O modo por região fica atrás do toggle enable_cep_region (data-enabled).
 * - Toggle OFF (campanha de limite único, ex.: 99,90 para o Brasil todo): a barra é a do
 *   tema, com o limite e os textos dele. Daqui só continua valendo a regra da COTAÇÃO REAL:
 *   frete calculado para o CEP deu grátis => a barra fecha (ver "cotacao real", abaixo).
 * - ANTES do CEP: barra escondida + linha-convite (não usa o fallback).
 * - ETIQUETA FIXA (13/10/2026): carrinho com UM produto e ele tem a etiqueta "Frete Grátis" => barra cheia,
 *   nos dois modos, sem CEP e sem cotação (ver "etiqueta fixa", abaixo). A cotação calculada manda sempre.
 * - DEPOIS do CEP: valor da região; se a UF não resolver, cai no default (fallback).
 * - Persiste CEP/UF em cookie (dias vindos do config). Sem valor hardcoded aqui.
 */
(function () {
  'use strict';

  var CFG = document.getElementById('plenitude-cep-region-config');
  if (!CFG) return;
  // Até 10/10/2026 este arquivo saía aqui com o toggle OFF, e a regra da cotação real ia junto:
  // na campanha 10.10 (limite único de 99,90) o devocional da Berith, que tem frete grátis em
  // qualquer valor, cotava "R$ 0,00" e a barra dizia "Faltam R$ 46,10" (visto pelo Diogo).
  var REGIONAL = CFG.dataset.enabled === 'true';

  // ---------- helpers ----------
  function num(x) { var v = parseFloat(String(x == null ? '' : x).replace(',', '.')); return isFinite(v) ? v : 0; }
  function money(v) { return 'R$ ' + v.toFixed(2).replace('.', ','); }

  var COOKIE = 'pl_cep_region';
  var COOKIE_DAYS = parseInt(CFG.dataset.cepCookieDays || '30', 10) || 30;
  var DEFAULT = num(CFG.dataset.defaultThreshold); // reais (fallback, pós-CEP)
  var MSG_PROGRESS = CFG.dataset.msgFreeShippingProgress || 'Faltam {{ amount }} para o FRETE GRÁTIS';
  var MSG_DONE = CFG.dataset.msgFreeShippingDone || 'Você tem FRETE GRÁTIS!';
  var MSG_PROMPT = CFG.dataset.msgCepPrompt || 'Informe seu CEP em "Calcular Frete" e veja o frete grátis da sua região';

  var THRESHOLDS = {
    sp: num(CFG.dataset.thresholdSp),
    sul_sudeste: num(CFG.dataset.thresholdSulSudeste),
    centro_oeste: num(CFG.dataset.thresholdCentroOeste),
    nordeste: num(CFG.dataset.thresholdNordeste),
    norte: num(CFG.dataset.thresholdNorte)
  };

  // Lista fechada UF -> região (valida a UF vinda do ViaCEP; nada de input cru).
  var UF_REGION = {
    SP: 'sp',
    RJ: 'sul_sudeste', MG: 'sul_sudeste', ES: 'sul_sudeste', PR: 'sul_sudeste', SC: 'sul_sudeste', RS: 'sul_sudeste',
    GO: 'centro_oeste', MT: 'centro_oeste', MS: 'centro_oeste', DF: 'centro_oeste',
    MA: 'nordeste', PI: 'nordeste', CE: 'nordeste', RN: 'nordeste', PB: 'nordeste', PE: 'nordeste', AL: 'nordeste', SE: 'nordeste', BA: 'nordeste',
    AC: 'norte', AM: 'norte', RR: 'norte', RO: 'norte', PA: 'norte', AP: 'norte', TO: 'norte'
  };

  var state = load(); // {cep, uf} | null
  var obs = null;
  var scheduled = false;

  // ---------- cookie ----------
  function setCookie(v) {
    var d = new Date(); d.setTime(d.getTime() + COOKIE_DAYS * 864e5);
    document.cookie = COOKIE + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function getCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function load() { try { return JSON.parse(getCookie() || 'null'); } catch (e) { return null; } }
  function save(cep, uf, persist) {
    state = { cep: cep, uf: uf };
    if (persist) { try { setCookie(JSON.stringify(state)); } catch (e) {} }
  }

  // ---------- regra de valor ----------
  function thresholdForUF(uf) {
    var region = UF_REGION[uf];
    var t = region ? THRESHOLDS[region] : 0;
    return (t && t > 0) ? t : DEFAULT; // UF fora do mapa -> default
  }
  // null => antes do CEP (mostra convite). número => aplica na barra.
  function currentThreshold() {
    if (!state) return null;                 // nunca digitou CEP
    if (state.uf) { var t = thresholdForUF(state.uf); return t > 0 ? t : null; }
    return DEFAULT > 0 ? DEFAULT : null;     // CEP digitado, sem região -> fallback
  }

  // ---------- render ----------
  function setText(el, msg, amountStr) {
    var parts = String(msg).split('{{ amount }}');
    el.textContent = '';
    el.appendChild(document.createTextNode(parts[0] || ''));
    if (parts.length > 1) {
      var strong = document.createElement('strong');
      strong.textContent = amountStr;
      el.appendChild(strong);
      el.appendChild(document.createTextNode(parts.slice(1).join('{{ amount }}')));
    }
  }
  // ---------- cotacao real ----------
  // O limite por regiao nao e a unica forma de ganhar frete gratis: produto com
  // perfil de envio proprio sai gratis em qualquer valor. Nesse caso o rodape ja
  // mostra "Frete R$ 0,00" e a barra insistia em "faltam R$ X" (visto em 01/09,
  // Biblia Slim Cruz: carrinho 139,80, cotacao 0,00, barra pedindo mais 40,10).
  //
  // Lemos o MESMO texto que o cliente le. A classe --placeholder e o que separa
  // "ainda nao calculou" de "calculou e deu zero" — sem ela, carrinho sem CEP
  // seria confundido com frete gratis e a barra encheria para todo mundo.
  var VAZIO = 'cart-checkout__shipping-value--placeholder';
  // 'gratis' | 'paga' | null (nenhum frete calculado na tela)
  function cotacao() {
    var els = document.querySelectorAll('[data-shipping-estimate-value]');
    var paga = false;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.classList.contains(VAZIO)) continue;
      var t = (el.textContent || '').trim().toLowerCase();
      if (!t) continue;
      if (t.indexOf('grát') === 0 || t.indexOf('grat') === 0) return 'gratis';
      var n = parseFloat(t.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'));
      if (isFinite(n) && n === 0) return 'gratis';
      if (isFinite(n) && n > 0) paga = true;
    }
    return paga ? 'paga' : null;
  }
  function cotacaoGratis() { return cotacao() === 'gratis'; }

  // ---------- etiqueta fixa ----------
  // Produto com a etiqueta "Frete Grátis" no cadastro tem regra própria no Embarcou: sai grátis em
  // qualquer valor e para qualquer CEP. A barra só sabia disso depois de o cliente calcular o frete;
  // sem a cotação ela pedia "Apenas mais R$ X" num carrinho que já tinha frete grátis (visto pelo
  // Diogo em 13/10/2026: kit Café com Deus Pai + Planner, R$ 131,22, em SP).
  //
  // Vale SÓ para carrinho com UM produto (qualquer quantidade). Medido na loja em 13/10: etiquetado
  // sozinho cota R$ 0,00 em SP, RJ e AM, mas dois etiquetados DIFERENTES às vezes pagam (Moldadas +
  // 365 Dias R$ 6,60; kit Café + Moldadas R$ 9,56 com R$ 181,12 no carrinho) — a regra do Embarcou é
  // por grupo de produtos. Dois produtos, ou um sem etiqueta: vale a conta por valor, como sempre.
  // A cotação calculada manda: havendo frete na tela (grátis ou pago), a etiqueta nem é consultada.
  //
  // De onde vem a etiqueta: o tema redesenha as linhas do carrinho NO NAVEGADOR a partir do /cart.js
  // (que não traz metacampo), então marcar a linha no Liquid não sobrevive ao primeiro "Comprar"
  // (visto no tema de teste em 13/10). Quem sabe é a seção sections/pl-frete-carrinho.liquid: um JSON
  // com a variante, o produto e a etiqueta de cada item do carrinho e, em página de produto, das
  // variantes dele. Vem embutido na página pelo layout e é buscado de novo (Section Rendering API)
  // quando aparece no carrinho uma variante ainda desconhecida.
  //
  // Casa pela VARIANTE, nunca pela chave da linha: a chave muda quando entra ou sai um desconto (medido
  // em 13/10: o cupom do Pix trocou …:17cd1d46 por …:45c554a8) e a etiqueta é do produto.
  var ETIQ = null;          // id da variante -> { p: produto, e: etiquetado }; só acumula
  var etiqTentou = {};      // carrinho (variantes) -> { n: buscas feitas, depois: quando pode a próxima }
  var etiqBuscando = false;
  var ETIQ_MAX = 3;         // por carrinho: a resposta pode vir sem o item (carrinho assentando, rede ruim)
  function guardarEtiquetas(lista) {
    for (var i = 0; lista && i < lista.length; i++) {
      if (lista[i] && lista[i].v != null) ETIQ[String(lista[i].v)] = { p: String(lista[i].p), e: lista[i].e === true };
    }
  }
  function lerEtiquetas(raiz) {
    var s = raiz && raiz.querySelector ? raiz.querySelector('script[data-pl-frete-carrinho]') : null;
    if (!s) return false;
    try {
      var d = JSON.parse(s.textContent || '{}');
      if (ETIQ === null) ETIQ = {};
      guardarEtiquetas(d.itens);
      guardarEtiquetas(d.pagina);
      return true;
    } catch (e) { return false; }
  }
  function buscarEtiquetas(carrinho) {
    if (etiqBuscando || !window.fetch || !window.DOMParser) return;
    var t = etiqTentou[carrinho] || (etiqTentou[carrinho] = { n: 0, depois: 0 });
    if (t.n >= ETIQ_MAX || Date.now() < t.depois) return;
    t.n += 1;
    t.depois = Date.now() + 1000 * t.n;
    etiqBuscando = true;
    fetch('/?section_id=pl-frete-carrinho', { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw 0; return r.text(); })
      .then(function (html) { lerEtiquetas(new DOMParser().parseFromString(html, 'text/html')); })
      .catch(function () {}) // sem a resposta a barra segue a conta por valor: nunca promete frete grátis no escuro
      .then(function () {
        etiqBuscando = false;
        scheduleApply(); // com a resposta, fecha se já der
        // veio sem o item? a próxima tentativa só vale depois da espera: volta a olhar quando ela vencer
        if (t.n < ETIQ_MAX) setTimeout(scheduleApply, 1000 * t.n + 50);
      });
  }
  function soProdutoEtiquetado(bar) {
    var caixa = bar.closest('cart-component') || bar.closest('drawer-component') || document;
    // .cart-item: só linha de verdade. O tema deixa na gaveta um <cart-item data-key="temp-cart-item">
    // vazio e sem classe (molde dele), que não é item do carrinho.
    var itens = caixa.querySelectorAll('cart-item.cart-item');
    if (!itens.length) return false;
    if (ETIQ === null && !lerEtiquetas(document)) ETIQ = {};
    var variantes = [], i;
    for (i = 0; i < itens.length; i++) {
      var chave = itens[i].getAttribute('data-key') || ''; // "<id da variante>:<hash>"
      // linha provisória: o tema a desenha (chave "temp-…") antes de o /cart/add.js voltar. Não é item ainda.
      if (chave.indexOf('temp-') === 0) return false;
      variantes.push(chave.split(':')[0]);
    }
    var produto = null;
    for (i = 0; i < variantes.length; i++) {
      var info = ETIQ[variantes[i]];
      if (!info) { buscarEtiquetas(variantes.slice().sort().join('|')); return false; } // variante nova: pergunta e, até saber, não fecha
      if (!info.e) return false;
      if (produto === null) produto = info.p;
      else if (produto !== info.p) return false;
    }
    return true;
  }
  function etiquetaFecha(bar) { return cotacao() === null && soProdutoEtiquetado(bar); }

  // Modo SEM região: quem desenha a barra é o tema (<progress-bar> do bundle). Só entramos
  // quando a cotação é grátis ou a etiqueta fixa fecha; quando deixa de ser, devolvemos o desenho a ele (render()).
  // O texto de "completo" é o do próprio tema (o mesmo de quem bate o limite), não o nosso.
  var MARCA = 'data-pl-cotacao-gratis';
  function cotacaoNaBarraDoTema(bar) {
    if (cotacaoGratis() || etiquetaFecha(bar)) {
      bar.setAttribute(MARCA, '');
      bar.setAttribute('data-complete', 'true');
      var fill = bar.querySelector('.progress-bar__bar-fill');
      if (fill) fill.style.width = '100%';
      var text = bar.querySelector('.progress-bar__text');
      if (text) {
        if (typeof bar.textComplete === 'string' && bar.textComplete) text.innerHTML = bar.textComplete;
        else text.textContent = MSG_DONE;
      }
    } else if (bar.hasAttribute(MARCA)) {
      bar.removeAttribute(MARCA);
      if (typeof bar.render === 'function') bar.render(); // volta o "Faltam R$ X" do tema
    }
  }

  // threshold null = antes do CEP: só chega aqui quando a etiqueta fixa fecha a barra.
  function renderBar(bar, threshold, etiqueta) {
    var value = num(bar.getAttribute('value')) / 100; // cart.total_price (centavos) mantido pelo tema
    var done = etiqueta || (threshold !== null && value >= threshold) || cotacaoGratis(); // etiqueta fixa, limite batido OU cotacao ja gratis
    if (threshold !== null) bar.setAttribute('max', Math.round(threshold * 100));
    bar.setAttribute('data-complete', done ? 'true' : 'false');
    bar.removeAttribute('hidden');
    var fill = bar.querySelector('.progress-bar__bar-fill');
    if (fill) fill.style.width = (done ? 100 : Math.min(100, value / threshold * 100)) + '%';
    var text = bar.querySelector('.progress-bar__text');
    if (text) {
      if (done) text.textContent = MSG_DONE;
      else setText(text, MSG_PROGRESS, money(Math.max(0, threshold - value)));
    }
  }
  function wrapOf(bar) { return bar.closest('.cart-heading__progress') || bar.parentElement; }
  function showCue(bar) {
    var wrap = wrapOf(bar); if (!wrap) return;
    var cue = wrap.querySelector('.pl-cep-cue');
    if (!cue) {
      cue = document.createElement('div');
      cue.className = 'pl-cep-cue';
      cue.setAttribute('role', 'status');
      wrap.appendChild(cue);
    }
    cue.textContent = '📍 ' + MSG_PROMPT;
    cue.hidden = false;
  }
  function hideCue(bar) {
    var wrap = wrapOf(bar);
    var cue = wrap && wrap.querySelector('.pl-cep-cue');
    if (cue) cue.hidden = true;
  }

  function applyAll() {
    if (obs) obs.disconnect(); // evita auto-disparo pelas nossas próprias mutações
    try {
      var bars = document.querySelectorAll('progress-bar.progress-bar');
      var i;
      if (!REGIONAL) {
        for (i = 0; i < bars.length; i++) cotacaoNaBarraDoTema(bars[i]);
        return;
      }
      var threshold = currentThreshold();
      for (i = 0; i < bars.length; i++) {
        var bar = bars[i];
        var etiqueta = etiquetaFecha(bar);
        if (threshold) { hideCue(bar); renderBar(bar, threshold, etiqueta); }
        else if (etiqueta) { hideCue(bar); renderBar(bar, null, true); }
        else { bar.setAttribute('hidden', ''); showCue(bar); }
      }
    } finally {
      if (obs) obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }
  function scheduleApply() {
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(function () { scheduled = false; applyAll(); });
  }

  // ---------- CEP ----------
  function lookup(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && !d.erro && d.uf) ? String(d.uf).toUpperCase() : null; })
      .catch(function () { return null; });
  }
  function onCep(raw) {
    var cep = String(raw || '').replace(/\D/g, '');
    if (cep.length !== 8) return;
    if (state && state.cep === cep) { scheduleApply(); return; } // já resolvido
    lookup(cep).then(function (uf) {
      if (uf && UF_REGION[uf]) save(cep, uf, true);   // resolvido -> persiste
      else save(cep, null, false);                    // falhou/UF fora -> só sessão (default)
      scheduleApply();
    });
  }
  function hookInputs() {
    var inputs = document.querySelectorAll('[data-shipping-cep], [data-plenitude-mini-cart-cep], input[name="cep"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.__plHooked) continue; inp.__plHooked = true;
      var fire = (function (el) { return function () { onCep(el.value); }; })(inp);
      inp.addEventListener('change', fire);
      inp.addEventListener('blur', fire);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') setTimeout(fire, 0); });
    }
  }

  // ---------- css do convite ----------
  function injectStyle() {
    if (document.getElementById('pl-cep-cue-style')) return;
    var s = document.createElement('style');
    s.id = 'pl-cep-cue-style';
    s.textContent =
      '.pl-cep-cue{font-size:13px;line-height:1.45;color:#5b4a55;text-align:center;padding:10px 14px;font-family:var(--montserrat,inherit)}' +
      // o tema tem display próprio na barra que ignora o atributo [hidden] — força o esconder
      'progress-bar.progress-bar[hidden]{display:none!important}' +
      // esconde a régua duplicada do bundle (lógica antiga da agência) — fica só a barra bonita
      '.plenitude-free-shipping-ruler{display:none!important}';
    document.head.appendChild(s);
  }

  // ---------- init ----------
  function init() {
    // Sem região não há convite de CEP nem UF a descobrir: nada de CSS do convite (ele esconde a
    // barra com [hidden], e a do tema nasce com esse atributo) nem de consulta ao ViaCEP.
    if (REGIONAL) { injectStyle(); hookInputs(); }
    applyAll();
    obs = new MutationObserver(function () { if (REGIONAL) hookInputs(); scheduleApply(); });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* pl-frete-recota: refaz a cotação quando o carrinho muda (10/10/2026).
   O estimador do tema (<cart-shipping-estimate>, bundle da agência) guarda na tela o resultado
   da última consulta e NÃO o refaz quando o carrinho muda: quem cotou "grátis" só com o
   devocional da Berith e depois pôs outro produto continuava lendo "grátis" e "Frete R$ 0,00"
   (o certo para aquele carrinho era R$ 6,38; medido no tema publicado). O contrário também:
   tirar o item pago deixava o "R$ 6,38" velho num carrinho que já tinha frete grátis.
   A barra de frete grátis lê esse mesmo valor (cotacaoGratis, acima), então errava junto.

   O estimador já sabe de qual carrinho é o resultado (resultItemFingerprint): quando o carrinho
   deixa de ser aquele, apagamos o resultado na hora (o resumo volta a "Informe seu CEP") e
   pedimos a cotação de novo com o CEP que está no campo. Custo: uma consulta de frete a mais por
   mudança de carrinho, só para quem já tinha calculado.
   Sobrevive a rebuilds do bundle: se os métodos sumirem ou mudarem de nome, vira no-op. */
(function () {
  'use strict';
  if (!window.customElements || !customElements.whenDefined) return;

  function soDigitos(v) { return String(v == null ? '' : v).replace(/\D/g, ''); }

  function recotar(el, cart) {
    if (!cart || !cart.item_count || cart.requires_shipping === false) return;
    if (!el.querySelector('[data-shipping-inline-result]')) return; // nada cotado na tela
    if (!el.resultItemFingerprint || el.itemFingerprint(cart) === el.resultItemFingerprint) return; // ainda é deste carrinho
    var cep = soDigitos(el.input && el.input.value);
    // valor velho sai já: o resumo volta ao convite e a barra deixa de se apoiar nele
    el.resultItemFingerprint = '';
    el.lastShownRate = null;
    el.clearInlineResult();
    // clearInlineResult tira o resultado ao lado do CEP, mas a linha "Frete" do resumo fica com o
    // valor velho enquanto a consulta nova não volta (medido: 2 s de "R$ 0,00" num carrinho pago)
    if (typeof el.updateSummaryLine === 'function') el.updateSummaryLine(null);
    if (cep.length !== 8 || !el.form || typeof el.form.requestSubmit !== 'function') return;
    // espera a pessoa parar de clicar em + e - antes de consultar
    clearTimeout(el.__plRecotaTimer);
    el.__plRecotaTimer = setTimeout(function () {
      if (el.isLoading || el.querySelector('[data-shipping-inline-result]')) return;
      if (soDigitos(el.input && el.input.value) !== cep) return; // trocou o CEP nesse meio-tempo
      el.form.requestSubmit();
    }, 400);
  }

  customElements.whenDefined('cart-shipping-estimate').then(function () {
    var E = customElements.get('cart-shipping-estimate');
    var P = E && E.prototype;
    if (!P || P.__plRecotaWrapped) return;
    if (typeof P.syncDisabled !== 'function' || typeof P.itemFingerprint !== 'function' ||
        typeof P.clearInlineResult !== 'function') return;
    P.__plRecotaWrapped = true;
    var orig = P.syncDisabled; // o tema chama a cada mudança do carrinho
    P.syncDisabled = function (cart) {
      orig.call(this, cart);
      try { recotar(this, cart); } catch (e) {}
    };
  }).catch(function () {});
})();

/* pl-pix-fix v2: o bundle da agencia calcula o TOTAL pix do carrinho com 5% cravado
   (updatePixDiscount -> Math.round(s*.05)). Este override le settings.pix_discount e:
   1) NAO aplica o % de novo quando um cupom AVISTA* ja esta aplicado no carrinho —
      o cupom E o desconto a vista; antes duplicava (item -10% e total -10% de novo);
   2) NUNCA desconta o frete estimado (o cupom no checkout tambem nao desconta frete);
   3) esconde a etiqueta do cupom AVISTA* no item e a linha "Descontos" do resumo (o
      preco "no Pix/boleto" do item ja comunica o desconto; o checkout segue integro);
   4) com o cupom AVISTA* no carrinho, calcula "parcelado em ate Nx" sobre o total do CARTAO
      (sem o desconto a vista), nao sobre o total do Pix (06/10/2026).
   O cupom entra no carrinho de quem passou pelo checkout com Pix marcado (a extensao pix-ui
   do app aplica o codigo) e volta para a loja: e um estado comum, nao uma excecao.
   Sobrevive a rebuilds do bundle (main-*.js): se os metodos sumirem, vira no-op. */
(function () {
  'use strict';
  if (!window.customElements || !customElements.whenDefined) return;

  var AVISTA = /^AVISTA/i; // familia de cupons "a vista" (AVISTA10OFF, AVISTA5OFF...)

  function money(cents) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  }
  function isAvista(code) { return AVISTA.test(String(code || '').trim()); }
  function hasAvista(cart) {
    return !!(cart && (cart.discount_codes || []).some(function (c) {
      return isAvista(c.code) && c.applicable !== false;
    }));
  }
  // quanto do desconto do carrinho e da familia AVISTA (ja embutido em cart.total_price).
  // O MESMO DADO VEM EM DUAS FORMAS (medido em 06/10/2026): /cart.js entrega a aplicacao "plana"
  // ({type, title, total_allocated_amount}); /cart/change.js e /cart/update.js entregam aninhada
  // ({amount, discount_application: {type, title, ...}}). Lendo so a plana, depois de qualquer
  // mudanca de quantidade o AVISTA nao era reconhecido e a linha "Descontos" reaparecia.
  function avistaDiscount(cart) {
    if (!cart) return 0;
    var avista = 0;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var ap = al.discount_application || {};
        if (ap.type === 'discount_code' && isAvista(ap.title)) avista += Number(al.amount) || 0;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (al) {
      var ap = al.discount_application || al;
      if (ap.type !== 'discount_code' || !isAvista(ap.title)) return;
      avista += Number(al.amount != null ? al.amount : ap.total_allocated_amount) || 0;
    });
    return avista;
  }
  // soma dos descontos que NAO sao da familia AVISTA — a linha "Descontos" mostra so eles
  function nonAvistaDiscount(cart) {
    if (!cart) return 0;
    return Math.max(0, (Number(cart.total_discount) || 0) - avistaDiscount(cart));
  }

  // etiqueta AVISTA* some na hora via CSS (:has); o JS abaixo cobre browser antigo
  (function css() {
    if (document.getElementById('pl-avista-ui-style')) return;
    var s = document.createElement('style');
    s.id = 'pl-avista-ui-style';
    s.textContent = '.cart-item__discount-tag:has([data-code^="AVISTA"]),.cart-item__discount-tag:has([data-code^="avista"]){display:none!important}';
    document.head.appendChild(s);
  })();

  customElements.whenDefined('cart-checkout').then(function () {
    var C = customElements.get('cart-checkout');
    if (!C || !C.prototype) return;

    // updateCheckoutInfo recebe o carrinho inteiro — guarda na instancia p/ o pix saber dos cupons
    if (typeof C.prototype.updateCheckoutInfo === 'function' && !C.prototype.__plAvistaWrapped) {
      C.prototype.__plAvistaWrapped = true;
      var orig = C.prototype.updateCheckoutInfo;
      C.prototype.updateCheckoutInfo = function (t) {
        this.__plCart = t || this.__plCart;
        orig.call(this, t);
        try { plAdjustRows(this); } catch (e) {}
      };
    }

    if (typeof C.prototype.updatePixDiscount === 'function') {
      C.prototype.updatePixDiscount = function (t) {
        var e = this.querySelector('.cart-checkout__pix-text');
        var i = this.querySelector('.cart-checkout__pix-value');
        if (!e || !i) return;
        var s;
        if (t !== undefined) {
          s = t;
          e.setAttribute('data-total-price', money(t));
        } else {
          s = Number(String(e.dataset.totalPrice || '').replace(/\D/g, '')) || 0;
        }
        var pct = Number(window.Shopify && Shopify.theme && Shopify.theme.settings && Shopify.theme.settings.pix_discount);
        if (!isFinite(pct) || pct <= 0 || pct >= 100) pct = 5;
        var frete = Number(this.shippingEstimateCents) || 0; // frete fica fora do desconto
        var produtos = Math.max(0, s - frete);
        if (!hasAvista(this.__plCart)) {
          produtos -= Math.round(produtos * (pct / 100)); // sem cupom: aplica a promessa a vista
        } // com cupom AVISTA*: produtos ja vieram descontados — nao aplica de novo
        i.textContent = money(produtos + frete);
      };
    }

    // parcelas do resumo: o bundle calcula sobre cart.total_price (+ frete), que com o cupom AVISTA*
    // ja e o total do Pix — saia "7x de R$ 43,63" para um carrinho de R$ 328,38 (certo: R$ 46,91).
    // Quem parcela paga no cartao, sem o desconto a vista: a base e o total SEM o AVISTA (+ frete).
    function plFixInstallments(el, cart) {
      if (!cart || !hasAvista(cart) || typeof el.updateInstallments !== 'function') return;
      var semAvista = (Number(cart.total_price) || 0) + avistaDiscount(cart);
      el.updateInstallments(semAvista + (Number(el.shippingEstimateCents) || 0));
    }
    // o bundle recalcula parcelas e total do Pix em dois caminhos, e os dois passam por aqui: mudanca do
    // carrinho (updateCheckoutInfo) e frete estimado (evento cart-shipping-estimate).
    // O caminho do frete chega com o carrinho que o bundle guardou ao carregar a pagina, que fica VELHO
    // depois de uma mudanca de quantidade (ela so dispara o evento cart:updated): parcela e total do Pix
    // voltavam ao valor de antes (visto no ar em 06/10/2026: "R$ 188,33" num carrinho de R$ 251,10, depois
    // de mudar a quantidade e calcular o frete). O carrinho mais novo que este elemento recebeu esta em
    // __plCart, que o updateCheckoutInfo acima guarda antes de chamar o original.
    if (typeof C.prototype.applyGrandTotalAndPaymentHints === 'function' && !C.prototype.__plParcelaWrapped) {
      C.prototype.__plParcelaWrapped = true;
      var origHints = C.prototype.applyGrandTotalAndPaymentHints;
      C.prototype.applyGrandTotalAndPaymentHints = function (t) {
        var cart = this.__plCart || t;
        origHints.call(this, cart);
        try { plFixInstallments(this, cart); } catch (e) {}
      };
    }

    // preco unitario dos itens: o re-render JS do bundle deriva o pix de item.price
    // (ja descontado pelo cupom) — reescreve com base no original_price do item
    function plFixItemPrices(cart) {
      if (!hasAvista(cart)) return;
      var pct = Number(window.Shopify && Shopify.theme && Shopify.theme.settings && Shopify.theme.settings.pix_discount);
      if (!isFinite(pct) || pct <= 0 || pct >= 100) pct = 5;
      (cart.items || []).forEach(function (it) {
        var fin = Number(it.final_price) || 0;
        var orig = Number(it.original_price) || fin;
        if (!fin || fin === orig) return; // item sem desconto de linha
        document.querySelectorAll('.cart-item product-price').forEach(function (pp) {
          var shown = Number(pp.getAttribute('data-unformatted-price')) || 0;
          if (shown !== fin) return; // card montado com o preco descontado -> corrige
          var pix = Math.ceil(orig * (1 - pct / 100));
          pp.setAttribute('data-price', money(orig));
          pp.setAttribute('data-unformatted-price', String(orig));
          pp.setAttribute('data-pix-price', money(pix));
          pp.setAttribute('data-unformatted-pix-price', String(pix));
          var cur = pp.querySelector('.product-price__current');
          if (cur) {
            for (var k = 0; k < cur.childNodes.length; k++) {
              var nd = cur.childNodes[k];
              if (nd.nodeType === 3 && /\d/.test(nd.textContent)) { nd.textContent = ' ' + money(pix) + ' '; break; }
            }
          }
        });
      });
    }

    // linha "Descontos", subtotal e etiquetas — AVISTA* fica invisivel no drawer
    function plAdjustRows(el) {
      var cart = el.__plCart;
      if (!cart) return;
      var extra = nonAvistaDiscount(cart);
      var row = el.querySelector('.cart-checkout__discounts');
      var val = el.querySelector('[data-cart-value="discounts"]');
      if (row) row.hidden = extra <= 0;
      if (val) val.textContent = extra > 0 ? '-' + money(extra) : money(0);
      // com cupom a vista: subtotal mostra o preco cheio; a linha pix mostra o final
      var sub = el.querySelector('[data-cart-value="subtotal"]');
      if (sub && hasAvista(cart)) {
        var cheio = (cart.items || []).reduce(function (acc, it) { return acc + (Number(it.original_line_price) || 0); }, 0);
        if (cheio > 0) sub.textContent = money(cheio);
      }
      // fallback sem :has(): esconde a etiqueta via JS
      document.querySelectorAll('.cart-item__discount-tag [data-code]').forEach(function (b) {
        if (isAvista(b.getAttribute('data-code'))) {
          var tag = b.closest('.cart-item__discount-tag');
          if (tag) tag.style.display = 'none';
        }
      });
      try { el.updatePixDiscount((Number(cart.total_price) || 0) + (Number(el.shippingEstimateCents) || 0)); } catch (e) {}
      try { plFixInstallments(el, cart); } catch (e) {} // carregamento da pagina: o Liquid tambem parte de cart.total_price
      plFixItemPrices(cart);
      // o re-render dos itens pode rodar depois deste hook — repassa no frame seguinte
      requestAnimationFrame(function () { try { plFixItemPrices(cart); } catch (e) {} });
    }

    // estado inicial (page load): busca o carrinho 1x p/ saber se ja ha cupom aplicado
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('cart-checkout').forEach(function (el) {
        el.__plCart = cart;
        try { plAdjustRows(el); } catch (e) {}
      });
    }).catch(function () {
      document.querySelectorAll('cart-checkout').forEach(function (el) {
        try { el.updatePixDiscount(); } catch (err) {}
      });
    });
  }).catch(function () {});
})();

/* pl-pix-cards: cards de beneficio (metaobject) com "N% OFF ... Pix" seguem a config
   settings.pix_discount — se o time mudar o % e esquecer o card, o front corrige. */
(function () {
  function sync() {
    var v = Number(window.Shopify && Shopify.theme && Shopify.theme.settings && Shopify.theme.settings.pix_discount);
    if (!isFinite(v) || v <= 0 || v >= 100) return;
    var label = String(v).replace('.', ',') + '% OFF';
    document.querySelectorAll('p.text-block').forEach(function (p) {
      if (!/pix/i.test(p.textContent || '')) return;
      p.querySelectorAll('strong, b').forEach(function (s) {
        var t = (s.textContent || '').trim();
        if (/^\d+(?:[.,]\d+)?%\s*OFF$/.test(t) && t !== label) s.textContent = label;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
